import React, {Component} from 'react';
import {connect} from 'react-redux';
import styled from 'styled-components';
import FontAwesome from 'react-fontawesome';
import posed from 'react-pose';
import PropTypes from 'prop-types';
import {searchInput} from '../store/actions';

const SearchIcon = styled(FontAwesome)`
  font-size: 32px;
  font-weight: normal;
  color: white;
  line-height: 75px;
`;

const SearchIconButton = styled.button `
  height: 75px;
  flex: 0 0 75px;
  width: 75px;
  border-radius: 50%;
  background-color: red;
  text-align: center;
  border: none;
  &:focus {
    outline: none;
  }
  &:hover {
    cursor: pointer;
  }
`;

const ErrorMessage = styled.p `
  color: #af1230;
`

const SearchInput = styled.input `
  height: 75px;
  min-width: 0;
  flex: 1 1 calc(100% - 75px);
  background-color: transparent;
  border: none;
  text-indent: 1rem;
  font-size: 1.5rem;
  font-family: 'Open Sans', sans-serif;
  font-weight: bold;
  &:focus {
    outline: none;
  }
`;
const TextInputConfig = {
  top: {
    y: '100%'
  },
  bottom: {
    y: '0%'
  }
};

const PosedTextInput = posed.div(TextInputConfig);
const FormContainer = styled(PosedTextInput)`
  position: relative;
  margin: 1rem 0 0 0;
	border: none;
	box-shadow: inset 1px 1px 3px 0 rgba(8,8,8,0.05), 0 2px 4px 0 rgba(0,0,0,0.09);
	border-radius: 37.5px;
  background-color: #F5F5F5;
  display: flex;
  justify-content: space-between;
  width: 90%;
  max-width: 575px;
  height: 75px;
`;

class TextInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: false,
      isVisible: true
    };
  }

  _handleEnterButton = e => {
    if (e.key === 'Enter') {
      this
        .props
        .buttonAction();
    }
  };

  render() {
    const {buttonAction, displaySearchResults, placeholder} = this.props;
    return (
      <FormContainer pose={displaySearchResults
        ? 'top'
        : 'bottom'}>
        <SearchInput
          placeholder={placeholder}
          onChange={this.props.searchInput}
          value={this.props.music.search}
          onKeyPress={this._handleEnterButton}/>
        <SearchIconButton onClick={buttonAction} type="button">
          <SearchIcon name="far fa-search"/>
        </SearchIconButton>
        {this.props.errorMessage && <ErrorMessage>{this.props.errorMessage}</ErrorMessage>}
      </FormContainer>
    );
  }
}

TextInput.propTypes = {
  buttonAction: PropTypes.func.isRequired,
  displaySearchResults: PropTypes.bool.isRequired,
  placeholder: PropTypes.string.isRequired
};

const mapStateToProps = state => ({music: state.music});

export default connect(mapStateToProps, {searchInput})(TextInput);



// WEBPACK FOOTER //
// ./src/components/TextInput.js